import { Box } from "@mui/joy";
import { ReactElement } from "react";
import { ArchivedLoadsDataGrid } from "../hooks/load/archived/archivedLoadsDataGrid";
import { Paper } from "@mui/material";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function ArchivedLoadsListRoute(): ReactElement {
  return (
    <Box sx={{ p: 2, width: "100%" }}>
      <Paper
        sx={{
          width: "100%",
          height: "calc(100vh - 146px)",
          display: "grid",
        }}
      >
        <ArchivedLoadsDataGrid />
      </Paper>
    </Box>
  );
}
